import { useState } from "react";
import useDidUpdateEffect from "src/share/hooks/useDidUpdateEffect";

export const useCasesViewType = (props) => {
  const viewType = props.match.params.viewType || "open";
  const getFilter = () => {
    switch (viewType) {
      case "closed":
        return { viewType };
      case "open":
        return { viewType };
      case "restricted":
        return { isPublic: false, viewType: "open" };
      default:
        return {};
    }
  };
  const [casesViewType, setCasesViewType] = useState(getFilter());
  useDidUpdateEffect(() => {
    setCasesViewType(getFilter());
  }, [viewType]);
  return { casesViewType };
};
